import { ref, onValue } from 'firebase/database';
import { db } from '../config/firebase';

let serverOffsetMs = 0;

// Listen to Firebase Realtime Database server time offset
const offsetRef = ref(db, '.info/serverTimeOffset');
onValue(offsetRef, (snap) => {
  serverOffsetMs = snap.val() || 0;
});

/**
 * Returns current time synchronized with Firebase server time (UTC).
 * Automatically cancels out device clock drift (e.g. if a computer/phone is 10s ahead or behind).
 */
export function getServerTime(): number {
  return Date.now() + serverOffsetMs;
}

export function getServerOffset(): number {
  return serverOffsetMs;
}

